import LazyImage from 'components/LazyImage';
import { Account } from 'model/IChat';
import React from 'react';

const CSS = require('./ExperienceHostAvatars.less');

interface ExperienceHostAvatarsProps {
  hosts: Account[];
}

const ExperienceHostAvatarsOptions = { width: 48, height: 48 };

function ExperienceHostAvatars({ hosts }: ExperienceHostAvatarsProps) {
  return (
    <div className={CSS.Avatars}>
      <LazyImage
        animate={true}
        width={48}
        height={48}
        className={CSS.Avatar}
        containerClass={CSS.AvatarContainer}
        src={hosts?.[0]?.photo}
        options={ExperienceHostAvatarsOptions}
        importance="low"
        loading="lazy"
        alt={`Host ${hosts?.[0]?.firstName}`}
        forceInView
      />
      <LazyImage
        animate={true}
        width={48}
        height={48}
        className={CSS.Avatar}
        containerClass={CSS.AvatarContainer}
        options={ExperienceHostAvatarsOptions}
        src={hosts?.[1]?.photo}
        importance="low"
        loading="lazy"
        alt={`Host ${hosts?.[1]?.firstName}`}
        forceInView
      />
    </div>
  );
}

export default ExperienceHostAvatars;
